<div class="wrapper" *ngIf="!cookiesAccepted">
    <h6>Cookies</h6>
    <p>By using this website, you accept our use of cookies.</p>
    <div class="buttons">
        <button class="button2" style="margin-right: 20px;" (click)="accept();">Accept</button>
        <button class="button2 greyed-button" [routerLink]="['/cookies']">More information</button>
    </div>
</div>